import cssVars from "css-vars-ponyfill";
import "element-matches-polyfill";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import main from "./main";

cssVars({});
main();
